// ======================================================================
// 📁 ValidatePlanDrawer.js
// PURPOSE:
//   Displays system-suggested operation schedule after validation.
//   This is SIMULATION ONLY — nothing is auto-saved.
// ======================================================================

import React, { useState } from "react";
import "./validation.css";
import ValidationOperationCard from "./ValidationOperationCard";

export default function ValidatePlanDrawer({
  open,
  validationResult,
  onClose,
  onAccept,
}) {
  // ------------------------------------------------------------------
  // 🔧 [2026-01-18 12:10]
  // Hooks must never be conditional
  // ------------------------------------------------------------------
  const [acceptedOperations, setAcceptedOperations] = useState([]);

  const { draft_id, validated_at, operations = [] } =
    validationResult || {};

  // ------------------------------------------------------------------
  // Safe early exit AFTER hooks and destructuring
  // ------------------------------------------------------------------
  if (!open || !validationResult) return null;

  // ------------------------------------------------------------------
  // Accept ONE operation (by draft_operation_id)
  // ------------------------------------------------------------------
  const acceptSingleOperation = (operation) => {
    const opId = operation.draft_operation_id;

    if (acceptedOperations.includes(opId)) return;

    setAcceptedOperations((prev) => [...prev, opId]);
  };

  // ------------------------------------------------------------------
  // Accept ALL non-blocked operations
  // ------------------------------------------------------------------
  const acceptAllOperations = () => {
    const accepted = operations
      .filter((op) => op.status !== "BLOCKED")
      .map((op) => op.draft_operation_id);

    setAcceptedOperations(accepted);

    // 🔧 [2026-01-18 12:10]
    // pass accepted operation IDs back to parent
    onAccept({
      ...validationResult,
      accepted_operation_ids: accepted,
    });
  };

  return (
    <>
      {/* Overlay */}
      <div
        className="ppe-validation-overlay"
        onClick={onClose}
      />

      {/* Drawer */}
      <div className="ppe-validation-drawer">
        {/* HEADER */}
        <div className="ppe-validation-header">
          <div>
            <h5 className="mb-0">
              Validate Production Plan
            </h5>

            <div className="small text-muted">
              Draft ID: {draft_id}
            </div>

            <div className="small text-muted">
              Validated at:{" "}
              {validated_at
                ? new Date(
                    validated_at
                  ).toLocaleString()
                : "—"}
            </div>
          </div>

          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={onClose}
          >
            ✕ Close
          </button>
        </div>

        {/* BODY */}
        <div className="ppe-validation-body">
          {operations.map((op) => (
            <ValidationOperationCard
              key={op.draft_operation_id}
              operation={op}
              isAccepted={acceptedOperations.includes(
                op.draft_operation_id
              )}
              onAcceptOperation={() =>
                acceptSingleOperation(op)
              }
            />
          ))}
        </div>

        {/* FOOTER */}
        <div className="ppe-validation-footer">
          <button
            className="btn btn-outline-secondary me-2"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="btn btn-success"
            onClick={acceptAllOperations}
          >
            ✅ Accept All Suggested Schedule
          </button>
        </div>
      </div>
    </>
  );
}
